<template>

  <div>

    <v-img class="image-marker" :aspect-ratio="16/9" :src="contenu.acfEvent.imagePrincipale.sourceUrl"></v-img>

    <div class="tw-flex tw-flex-col tw-items-center content-marker">
      <h2 class="text-1-5 tw-text-blue tw-font-bold tw-text-center"> {{ contenu.title }}</h2>
      <h3 class="text-1-5 tw-text-blue tw-text-center">{{ contenu.acfEvent.organisateurs }}</h3>

      <div class="text-1-2 tw-text-center" v-html="contenu.acfEvent.aPropos.substr(0, 250)+'\u2026'">
      </div>

      <div v-if="contenu.acfEvent.dates.length > 1" class="tw-flex tw-flex-col tw-w-full">
        <div v-for="(date , index) in contenu.acfEvent.dates" :key="index" class="tw-flex tw-items-center tw-justify-between tw-p-4 border-top">
          <div class="text-1-2 tw-text-blue tw-font-bold">{{ date.dateDebut }} <span v-if="date.dateFin" class="text-1-2 tw-text-blue tw-font-bold"> - {{ date.dateFin}}</span> </div>
          <v-btn color="primary" class="btn-shape" @click="selectDate(date)">
            Voir
          </v-btn>
        </div>
      </div>

      <v-btn v-else color="primary" class="tw-mb-4 btn-shape" @click="selectDate(contenu.acfEvent.dates[0])">
        En savoir plus
      </v-btn>

    </div>
  </div>
</template>

<script>
import store from "../../store";
import router from "../../router";
export default {
  name: "MarkerPopup",
  props: ['contenu'],
  methods: {
    selectDate(date) {
      store.commit('setCurrentEvent' , date)
      store.commit('setFixedEvent' , true)
      router.push('/evenement/'+this.contenu.slug)
    },
  }
}
</script>

<style lang="scss">

</style>
